module.exports = __webpack_public_path__ + "static/img/banner.8dae916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/banner.png
// module id = 5bzC
// module chunks = 0